import { render, staticRenderFns } from "./IdentityCheck.vue?vue&type=template&id=7dfcd8b8"
import script from "./IdentityCheck.vue?vue&type=script&lang=ts"
export * from "./IdentityCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports